// extracted by mini-css-extract-plugin
export var navItemActiveGradient = "nav-module--nav-item-active-gradient--1zz0T";
export var navLinkItemHoverGradient = "nav-module--nav-link-item-hover-gradient--38aBj";
export var mobileNavLinksBoxShadow = "nav-module--mobile-nav-links-box-shadow--5NSdy";
export var logoBoxShadow = "nav-module--logo-box-shadow--154MY";